import { render, staticRenderFns } from "./expertBatch.vue?vue&type=template&id=04e8c907&"
import script from "./expertBatch.vue?vue&type=script&lang=js&"
export * from "./expertBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports